import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  startExam,
  finishExam,
  checkAnswers,
  getGroupsWithTeacherId,
  getSubjectsWithIntitutionId,
  getFilteredTeacherExams,
  deleteExam,
} from "../../../actions";
import { Context } from "../../../defaults";
import { message, Table, Row, Col, Select, Tooltip, Popconfirm } from "antd";
import moment from "moment";
import CreateExam from "./CreateExam";
import {
  DeleteTwoTone,
  EditTwoTone,
  CheckOutlined,
  PlusOutlined,
  AuditOutlined,
} from "@ant-design/icons";

export const ExamTable = ({
  added,
  setAdded,
  setActive,
  selectedGroup,
  setSelectedGroup,
  selectedSubject,
  setSelectedSubject,
}) => {
  const { dictionary, language, setLoading, setStorageCheckExam } = useContext(
    Context
  );
  const history = useHistory();
  const [exams, setExams] = useState();
  const [studentGroups, setStudentGroups] = useState(false);
  const [subjects, setSubjects] = useState();
  const [edit, setEdit] = useState(false);
  const [selectedExam, setSelectedExam] = useState();

  useEffect(() => {
    getGroupsWithTeacherId().then(({ data }) => setStudentGroups(data));
    getSubjectsWithIntitutionId().then(({ data }) => setSubjects(data));
  }, [added]);

  useEffect(() => {
    if (!!selectedGroup && !!selectedSubject) getFilteredExams();
    else setExams([]);
  }, [selectedGroup, selectedSubject]);

  const getFilteredExams = () => {
    setLoading(true);
    getFilteredTeacherExams(selectedGroup, selectedSubject)
      .then(({ data }) => {
        setExams(data);
        setLoading(false);
      })
      .catch(() => {
        message.error(dictionary?.SomethingWentWrong[language], 4);
        setLoading(false);
      });
  };

  const start = (id) => {
    setLoading(true);
    startExam(id)
      .then(() => {
        message.success(dictionary?.OperationSuccessful[language], 4);
        getFilteredExams();
      })
      .catch(() => {
        setLoading(false);
        message.error(dictionary?.OperationError[language], 4);
      });
  };

  const check = (exam) => {
    setStorageCheckExam({
      id: exam.id,
      subjectId: exam.subjectId,
      groupId: exam.groupId,
    });
    history.push("/control-panel/checkExam");
  };

  const finish = (id) => {
    setLoading(true);
    finishExam(id)
      .then(({ data }) => {
        !data && message.success(dictionary?.OperationSuccessful[language], 4);
        !!data && message.error(dictionary?.[`${data}`][language]);
        getFilteredExams();
      })
      .catch(() => {
        setLoading(false);
        message.error(dictionary?.SomethingWentWrong[language]);
      });
  };

  const onSelectExam = (id) => {
    const exam = exams.filter((x) => x.id === id)[0];
    setSelectedExam();
    setSelectedExam(unFormattedRequest(exam));
    setEdit(true);
  };

  const confirm = (id) => {
    setLoading(true);
    deleteExam(id)
      .then(() => {
        message.success(dictionary?.OperationSuccessful[language]);
        getFilteredExams();
      })
      .catch(() => {
        setLoading(false);
        message.error(dictionary?.SomethingWentWrong[language]);
      });
  };

  function unFormattedRequest(data) {
    var formattedOptions = [];

    for (let i = 1; i <= 5; i++) {
      var model = null;
      var allAmount = 0;
      data.options.map((el) => {
        if (el.questionTypeId === i) {
          allAmount += el.amount;
          model = {
            ...model,
            questionTypeId: el.questionTypeId,
            amount: allAmount,
          };
          if (el.level === "A") model = { ...model, LevelA: el.amount };
          if (el.level === "B") model = { ...model, LevelB: el.amount };
          if (el.level === "C") model = { ...model, LevelC: el.amount };
        }
      });
      if (!!model) formattedOptions = [...formattedOptions, model];
    }

    return {
      ...data,
      options: formattedOptions,
      startTime: timeFormating(data?.startTime),
      endTime: timeFormating(data?.endTime),
      examDate: moment(data?.examDate),
      endDate: moment(data?.endDate),
    };
  }

  const timeFormating = (time) => {
    var day = moment().zone("GMT");
    var splitTime = time.split(/:/);
    return day
      .hours(parseInt(splitTime[0]))
      .minutes(parseInt(splitTime[1]))
      .seconds(0)
      .milliseconds(0);
  };

  const columns = [
    {
      title: `${dictionary?.ExamName[language]}`,
      dataIndex: "name",
      key: "name",
    },
    {
      title: `${dictionary?.ExamStartDate[language]}`,
      dataIndex: "examDate",
      key: "examDate",
      render: (examDate) => moment(examDate).format("L"),
    },
    {
      title: `${dictionary?.ExamStartTime[language]}`,
      dataIndex: "startTime",
      key: "startTime",
    },
    {
      title: `${dictionary?.ExamEndDate[language]}`,
      dataIndex: "endDate",
      key: "endDate",
      render: (endDate) => moment(endDate).format("L"),
    },
    {
      title: `${dictionary?.ExamEndTime[language]}`,
      dataIndex: "endTime",
      key: "endTime",
    },
    {
      title: `${dictionary?.DistributeVarians[language]}`,
      key: "actionAdd",
      width: 100,
      render: (id) => (
        <>
          <Tooltip
            placement="top"
            title={id.status === 2 && dictionary?.DistributeVarians[language]}
          >
            <Popconfirm
              placement="bottom"
              title={dictionary?.AreYouSureToStartExam[language]}
              onConfirm={() => start(id.id)}
              okText={dictionary?.Yes[language]}
              cancelText={dictionary?.No[language]}
              disabled={id.status !== 2}
            >
              <PlusOutlined
                key="add"
                style={{
                  fontSize: "20px",
                  color: id.status !== 2 ? "#808080" : "#ffa500",
                }}
              />
            </Popconfirm>
          </Tooltip>
        </>
      ),
    },
    {
      title: `${dictionary?.CheckAnswers[language]}`,
      key: "actionCheck",
      width: 100,
      render: (id) => (
        <>
          <Tooltip
            placement="top"
            title={id.status === 3 && dictionary?.CheckAnswers[language]}
          >
            <Popconfirm
              placement="bottom"
              title={dictionary?.AreYouSureToCheck[language]}
              onConfirm={() => check(id)}
              okText={dictionary?.Yes[language]}
              cancelText={dictionary?.No[language]}
              disabled={id.status !== 3}
            >
              <CheckOutlined
                key="check"
                style={{
                  fontSize: "20px",
                  color: id.status !== 3 ? "#808080" : "#00cd00",
                }}
              />
            </Popconfirm>
          </Tooltip>
        </>
      ),
    },
    {
      title: `${dictionary?.FinishExam[language]}`,
      key: "actionFinish",
      width: 100,
      render: (id) => (
        <>
          <Tooltip
            placement="top"
            title={id.status === 3 && dictionary?.FinishExam[language]}
          >
            <Popconfirm
              placement="bottom"
              title={dictionary?.AreYouSureToFinish[language]}
              onConfirm={() => finish(id.id)}
              okText={dictionary?.Yes[language]}
              cancelText={dictionary?.No[language]}
              disabled={id.status !== 3}
            >
              <AuditOutlined
                key="finish"
                style={{
                  fontSize: "20px",
                  color: id.status !== 3 ? "#808080" : "#ff1bff",
                }}
              />
            </Popconfirm>
          </Tooltip>
        </>
      ),
    },
    {
      title: `${dictionary?.Edit[language]}`,
      key: "action",
      width: 100,
      align: "center",
      render: ({ id }) => (
        <>
          <Tooltip placement="top" title={dictionary?.Edit[language]}>
            <EditTwoTone
              key="edit"
              style={{ fontSize: "20px" }}
              onClick={() => onSelectExam(id)}
            />
          </Tooltip>
        </>
      ),
    },
    {
      title: `${dictionary?.Delete[language]}`,
      key: "action",
      width: 100,
      align: "center",
      render: ({ id }) => (
        <>
          <Tooltip placement="top" title={dictionary?.Delete[language]}>
            <Popconfirm
              placement="bottom"
              title={dictionary?.AreYouSureToDelete[language]}
              onConfirm={() => confirm(id)}
              okText={dictionary?.Yes[language]}
              cancelText={dictionary?.No[language]}
            >
              <DeleteTwoTone
                key="delete"
                style={{ fontSize: "20px" }}
                twoToneColor="#eb2f96"
              />
            </Popconfirm>
          </Tooltip>
        </>
      ),
    },
  ];

  return (
    <>
      <Row style={{ marginTop: "30px" }} gutter={16}>
        <Col span={12}>
          <Select
            placeholder={dictionary?.Group[language]}
            allowClear={true}
            showSearch={true}
            style={{ width: "100%" }}
            value={selectedGroup}
            onChange={setSelectedGroup}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {studentGroups &&
              studentGroups.map((el) => {
                return (
                  <Select.Option value={el.id} key={el.id}>
                    {el.name}
                  </Select.Option>
                );
              })}
          </Select>
        </Col>
        <Col span={12}>
          <Select
            placeholder={dictionary?.Subject[language]}
            allowClear={true}
            showSearch={true}
            style={{ width: "100%" }}
            value={selectedSubject}
            onChange={setSelectedSubject}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {subjects &&
              subjects.map((el) => {
                return (
                  <Select.Option value={el.id} key={el.id}>
                    {el.name}
                  </Select.Option>
                );
              })}
          </Select>
        </Col>
      </Row>
      <Table
        style={{ marginTop: 24 }}
        scroll={{ x: 1300 }}
        columns={columns}
        dataSource={exams}
        rowKey="id"
      />
      {!!edit && (
        <CreateExam
          selectedExam={selectedExam}
          setSelectedExam={setSelectedExam}
          edit={edit}
          setEdit={setEdit}
          setAdded={setAdded}
          setActive={setActive}
          getFilteredExams={getFilteredExams}
          setSelectedGroup={setSelectedGroup}
          setSelectedSubject={setSelectedSubject}
        />
      )}
    </>
  );
};
